import { FormEditor } from './form-editor.base.model';
import { File } from '../files/files.model';
import { Entity } from '../entities/entity.model';

export class ContainedMany extends FormEditor<Array<any>> {
  controlType = 'containedMany';
  files: Array<File>;
  entities: Array<Entity>;
  isHalf: boolean;
  imgOnly: boolean;
  upload: boolean;

  constructor(options: {} = {}) {
    super(options);
    this.files = options['files'] || [];
    this.entities = options['entities'] || [];
    this.isHalf = (typeof options['isHalf'] !== 'undefined' ? options['isHalf'] : true);
    this.imgOnly = (typeof options['imgOnly'] !== 'undefined' ? options['imgOnly'] : true);
    this.upload = (typeof options['upload'] !== 'undefined' ? options['upload'] : true);
  }
}
